import React, { useContext, useState, useEffect } from 'react'
import { IoList } from "react-icons/io5";
import { RiSettings2Line } from "react-icons/ri";
import { SideberContext } from '../context/SidebarContext';
import { NavbarContext } from '../context/NavbarContext';
import { getAppData } from '../apiService';
import { ApiContext } from '../context/ApiContext';
import { EventsContext } from '../context/EventsContext';
import { ShimmerBadge, ShimmerText, ShimmerTitle } from "react-shimmer-effects";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


function Navbar() {
  const { data, setData, setSongData, setCategories, setCategories2, setCategories3, setSchedule, myDay, setMyNews, setAllEvents, isApple, setIsApple,metaData,setMetaData } = useContext(ApiContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { mySidebar, setMySidebar, mySidebarSetting, setMySidebarSetting } = useContext(SideberContext)
  const { navHeading, setNavHeading } = useContext(NavbarContext)
  const { setAllAlbums } = useContext(EventsContext)
  const navigate =useNavigate();
  // console.log(mySidebarSetting,"sidebar");
  const uid = process.env.REACT_APP_uid;
  const idss = process.env.REACT_APP_id;
  const { t } = useTranslation();

  useEffect(() => {
    if (navigator.userAgent.match(/iPhone|iPod/i)) {
      setIsApple(true); // Set the state for Apple users
    }
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      // console.log('Fetching data...');
      try {
        const result = await getAppData(`/api.php?set=Events&page=1&offset=5000&uid=${uid}`);
        if (result.success === 1) {
          // console.log(result.result.data, 'fetched data');
          setAllEvents(result.result.data);
          // setDataFetched(true); // Set dataFetched to true after fetching data
        }
      } catch (err) {
        setError('Error fetching data. Please try again later.');
        console.error('Error:', err);
      } finally {
        setLoading(false);
        // console.log('Data fetch complete');
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      // setLoading(true)
      try {
        const result = await getAppData(`/api.php?set=News&page=1&offset=5000&uid=${uid}`);
        if (result.success == 1) {
          //   console.log(result.result.data,"nws dta");
          setMyNews(result.result.data);
        }
      } catch (err) {
        setError('Error fetching data. Please try again later.');
        console.error('Error:', err);
      } finally {
        // setLoading(false);
      }

    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      // setLoading(true)
      try {
        const result = await getAppData(`/api.php?set=Album&page=1&offset=5000&uid=${uid}`);
        // console.log(result.result.data);

        if (result.success == 1) {
          setAllAlbums(result.result.data);
        }
      } catch (err) {
        setError('Error fetching data. Please try again later.');
        console.error('Error:', err);
      } finally {
        // setLoading(false);
      }

    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getAppData(`/api.php?set=Schedule&day=${myDay}&uid=${uid}`);
        if (result.success == 1) {
          // console.log(result.result.data,"categs");                          
          setSchedule(result.data.result);
        }
      } catch (err) {
        setError('Error fetching data. Please try again later.');
        console.error('Error:', err);
      } finally {
        // setLoading(false);
      }

    };

    fetchData();
  }, [myDay]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getAppData(`/api.php?set=Category&uid=${uid}&page=1&offset=10000`);
        if (result.success == 1) {
          // console.log(result.result.data,"categs");
          setCategories(result.result.data);
        }
      } catch (err) {
        setError('Error fetching data. Please try again later.');
        console.error('Error:', err);
      } finally {
        // setLoading(false);
      }

    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result2 = await getAppData(`/api.php?set=Podcast&page=1&offset=10000&uid=${uid}`)
        if (result2.success == 1) {
          // console.log(result2.result.data,"categs");
          setCategories2(result2.result.data);
        }
      } catch (err) {
        setError('Error fetching data. Please try again later.');
        console.error('Error:', err);
      } finally {
        // setLoading(false);
      }

    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result2 = await getAppData(`/api.php?set=Interviews&page=1&offset=5000&uid=${uid}`)
        if (result2.success == 1) {
          // console.log(result2.result.data,"categs");
          setCategories3(result2.result.data);
        }
      } catch (err) {
        setError('Error fetching data. Please try again later.');
        console.error('Error:', err);
      } finally {
        // setLoading(false);
      }

    };

    fetchData();
  }, []);
  // const fetchData = async () => {
  //   try {
  //     const response = await fetch('https://english-ekamsoftware.radioca.st/stats?sid=1&json=1');
  //     const data = await response.json();
  //     // console.log(data, "here is data");
  //     setSongData(data.songtitle); // Set the song data
  //     // console.log(data.songtitle,"song dta");
      
  //     // setLoading(false); // Data fetched, stop the loading spinner
  //   } catch (error) {
  //     console.error("Error fetching song data:", error);
  //     // setLoading(false); // Stop loading even on error
  //   }
  // };

  // useEffect(() => {
  //   // Fetch data immediately on mount
  //   fetchData();
  
  //   // Set up the interval
  //   const intervalId = setInterval(fetchData, 2000);
  
  //   // Clean up the interval on component unmount
  //   return () => clearInterval(intervalId);
  // }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getAppData(`/api.php?set=App&id=${idss}`);
        if (result.success == 1) {
          // console.log(result.app[0],"mete");
          setData(result.app[0]);
          
        }
      } catch (err) {
        setError('Error fetching data. Please try again later.');
        console.error('Error:', err);
      } finally {
        setLoading(false);
      }

    };

    fetchData();
  }, []);

  useEffect(()=>{
    if(data){     
      console.log(data,"dd");
let metadataurl = data.song_metadata;
console.log(metadataurl,"mmmm");

            if(metadataurl){
              const fetchData = async () =>{
                try{
                  const result = await fetch(metadataurl);
                  const data = await result.json();
                        console.log("i am in",data);
                  if(data){
                    console.log(data,"mta");
                    setSongData(data.songtitle);
                  }
                }catch(err){
setError('Error fetching data. Please try again later.');
        console.error('Error:', err);
                }
              
              }
              fetchData()
                // Set up the interval
    const intervalId = setInterval(fetchData, 2000);
  
    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
              
            }
    }

  },[data])

  if (loading) {
    // return (
    //     <div className="loader-container">
    //         <div className="dot-wave-loader">
    //             <div></div>
    //             <div></div>
    //             <div></div>
    //             <div></div>
    //             <div></div>
    //         </div>
    //     </div>
    // );
    return (
      // <Shimmer width="100%" height="40px" />
      // <ShimmerText line={3} gap={10} />
      <div className='Main-navbar1' >
        <div className='Main-navbar1-inner-div'>
          <IoList style={{ fontSize: "22px", cursor: "pointer" }} onClick={() => setMySidebar(true)} />
          <div className='shimmerTitle-navbar'>
            <ShimmerTitle line={1} gap={10} variant="primary" />
          </div>
          <RiSettings2Line style={{ fontSize: "22px", cursor: "pointer" }} onClick={() => setMySidebarSetting(true)} />
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <>
        <div className="blur-background"></div>
        <div className="error-container">
          <p>{error}</p>
        </div>
      </>
    )
  }



  return (
    <>
      <div className='Main-navbar1'>
        <div className='Main-navbar1-inner-div'>
          <IoList style={{ fontSize: "22px", cursor: "pointer" }} onClick={() => setMySidebar(true)} />
          <h2 className='Main-navbar1-heading'>
            {/* {navHeading && navHeading.length > 30 ? navHeading.substring(0, 32) + '...' : navHeading} */}
            {t("Home.Title")}
            </h2>  {/* //if user click on option then set value */}
          <RiSettings2Line style={{ fontSize: "22px", cursor: "pointer" }} onClick={() => setMySidebarSetting(true)} />
        </div>
      </div>

    </>
  )
}

export default Navbar